import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import config from "../../../config/config";
import { getToken } from "../../../utils/localStorageMethods";

const apiUrl = config.Url;

export const registrationSlice = createApi({
  reducerPath: "registrationSlice",
  baseQuery: fetchBaseQuery({
    baseUrl: `${apiUrl}`,
    credentials: "include",
    prepareHeaders: (headers) => {
      const token = getToken(); // Get token from cookies
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
        headers.set("ngrok-skip-browser-warning", "true");
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    // GET ALL STUDENT FEE API FOR (PARENT)
    getParentPayment: builder.query({
      query: (parentId) =>
        parentId
          ? `subscription-payment/parent-summary?parentId=${parentId}`
          : "subscription-payment/parent-summary",
    }),

    registerParent: builder.mutation({
      query: (data) => ({
        url: "parent/complete-registration",
        method: "POST",
        body: data,
      }),
    }),
    parentPayment: builder.mutation({
      query: (data) => ({
        url: "subscription-payment",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useGetParentPaymentQuery,
  useRegisterParentMutation,
  useParentPaymentMutation,
} = registrationSlice;
